/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { translateSkipAreas } from 'Utils/Constants';

const hexToRGB = (hex: string, alpha: number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }
  return `rgb(${r}, ${g}, ${b})`;
};

type Props = {
  xAxis: string[] | undefined
  seriesDate: { y: number; x: Date }[] | undefined
  seriesColor: string
  seriesName: string
};

const BarChart: React.FC<Props> = function BarChart(props: Props) {
  const { seriesColor, seriesDate, seriesName } = props;
  const options = {
    credits: {
      enabled: false,
    },
    chart: {
      zoomType: 'xy',
      type: 'column',
      height: 250,
    },
    title: {
      text: '',
    },
    subtitle: {
      text: '',
    },
    xAxis: {
      type: 'datetime',
      minTickInterval: 28 * 24 * 3600 * 1000,
      endOnTick: true,
      labels: {
        staggerLines: 1,
        formatter() {
          return Highcharts.dateFormat('%b', this.value); // this.value
        },
      },
    },
    tooltip: {
      shared: true,
      useHTML: true,
      formatter() {
        return (
          // this.x ${this.y}
          `<span style="font-size:16px; font-family: Roboto; color: #61769E;">${Highcharts.dateFormat(
            '%b %e, %Y',
            this.x,
          )}</span><table><br/>`
          + `<b style="font-size:32px; color:${seriesColor}; font-family: Roboto; display: flex; justify-content: center;">
          ${this.y}</b>`
          + '</table>'
        );
      },
    },
    plotOptions: {
      series: {
        turboThreshold: 1000000
      },
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        states: {
          hover: {
            color: seriesColor,
          },
        },
      },
    },
    series: [
      {
        name: seriesName,
        data: seriesDate,
        color: hexToRGB(seriesColor, 0.6),
      },
    ],
  };
  const { xAxis } = props;
  return (
    <div className={`barchart ${translateSkipAreas}`}>
      {xAxis?.length ? (
        <HighchartsReact highcharts={Highcharts} options={options} />
      ) : null}
    </div>
  );
};

export default BarChart;